module.exports = __webpack_public_path__ + "static/media/1_like_icon.567c7218.svg";